module.exports = __webpack_public_path__ + "img/slide2_mobile.c481a28e.jpg";